import { convertDateRangeToDates } from "@wingspanhq/fe-component-library";
import { WorkLogStatus } from "@wingspanhq/payments/dist/interfaces";
import { ApiQueryListWorkLogs } from "../../../../../services/workLog";
import { UrlQuerySort } from "../../../../../shared/hooks/useUrlQuery";
import { getApiDirectionFromTable } from "../../../../../shared/utils/sorting";
import { Filter, SortField, WorkLogPayeeTabFilterStatus } from "./types";

export function createListRequest(
  userId: string,
  filter?: Filter,
  sort?: UrlQuerySort<SortField>
): ApiQueryListWorkLogs {
  const request: ApiQueryListWorkLogs = {
    "filter[payeeId]": userId,
    "sort[updatedAt]": getApiDirectionFromTable(sort?.direction) || "desc"
  };

  if (filter?.payerId) {
    request["filter[payerId]"] = filter.payerId;
  }

  if (filter?.assignmentId) {
    request["filter[payerPayeeEngagementId][=]"] = filter.assignmentId;
  }

  // Status filtering based on backend WorkLogStatus enum
  if (filter?.status) {
    switch (filter.status) {
      case WorkLogPayeeTabFilterStatus.InProgress:
        // In-progress tab shows both Draft and InProgress work logs for payee view
        request["filter[status][in]"] = [
          WorkLogStatus.Draft,
          WorkLogStatus.InProgress
        ];
        break;
      case WorkLogPayeeTabFilterStatus.Submitted:
        // Submitted - awaiting payer approval (maps to backend InReview status)
        request["filter[status][=]"] = WorkLogStatus.InReview;
        break;
      case WorkLogPayeeTabFilterStatus.Approved:
        request["filter[status][=]"] = WorkLogStatus.Approved;
        break;
      case WorkLogPayeeTabFilterStatus.Rejected:
        request["filter[status][=]"] = WorkLogStatus.Rejected;
        break;
    }
  }

  if (filter?.dateRange) {
    const dateRange = convertDateRangeToDates(filter.dateRange);
    if (dateRange) {
      request["filter[startDate][>]"] = dateRange.start;
      request["filter[startDate][<]"] = dateRange.end;
    }
  }

  return request;
}
